export enum PanelType {
  Details = "details",
  Ancillaries = "ancillaries",
  Accessibility = "accessibility",
}
